import { Injectable } from '@angular/core';
import { IPostExtra } from "libraries/service/resources/model/booking/air/IAirCreateBooking";

@Injectable({providedIn: "root"})
export class PostExtraService {

    private static readonly POST_EXTRA: string = '$postExtra';

    public getPostExtra(): IPostExtra {
        try {
            const postExtraStr: string = sessionStorage.getItem(PostExtraService.POST_EXTRA);
            return typeof postExtraStr === 'object'  ? postExtraStr : JSON.parse(postExtraStr || "{}") as IPostExtra;
        } catch (e) {
            return {};
        }

    }
}
